import { render, staticRenderFns } from "./AllProjectsChart.vue?vue&type=template&id=1a1ccc82&scoped=true&"
import script from "./AllProjectsChart.vue?vue&type=script&lang=js&"
export * from "./AllProjectsChart.vue?vue&type=script&lang=js&"
import style0 from "./AllProjectsChart.vue?vue&type=style&index=0&id=1a1ccc82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ccc82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1ccc82')) {
      api.createRecord('1a1ccc82', component.options)
    } else {
      api.reload('1a1ccc82', component.options)
    }
    module.hot.accept("./AllProjectsChart.vue?vue&type=template&id=1a1ccc82&scoped=true&", function () {
      api.rerender('1a1ccc82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chartjs/AllProjectsChart.vue"
export default component.exports